<template>
  <div class="video-box">
    <video
      :src="path"
      id="cover-video"
      loop
      autoplay
      muted
      :controls="false"
      :playsinline="true"
      :webkit-playsinline="true"
      :x-webkit-airplay="true"
      x5-video-player-type="h5"
      :x5-video-player-fullscreen="true"
      preload="auto"
      v-if="flag"
    ></video>
    <object v-else width="100%" :height="height" :data="path">
      <param name="movie" :value="path" />
      <param name="allowFullScreen" value="true" />
      <param name="flashvars" value="mute=true" />
      <embed
        :src="path"
        type="application/x-shockwave-flash"
        allowfullscreen="true"
        flashvars="mute=true"
        width="100%"
        :height="height"
      />
    </object>
    <div class="bg"></div>
    <div class="desc">私たちのチームへようこそ</div>
  </div>
</template>
<script>
export default {
  name: 'CustomVideo',
  data() {
    return {
      height: '',
      flag: true,
      path: process.env.VUE_APP_FILE_URL + 'index.mp4'
    }
  },
  mounted() {
    const ua = window.navigator.userAgent.toLowerCase()
    const new_ie = ua.indexOf('trident/')
    //兼容ie和360兼容模式
    if (window.navigator.mimeTypes[40] || !window.navigator.mimeTypes.length || new_ie !== -1) {
      // this.flag = false
      this.height = window.innerHeight
      const video = document.getElementById('cover-video')
      video.style.height = '100%'
    }
  }
}
</script>

<style scoped lang="scss">
.video-box {
  //height: 60vh;
  height: calc(100vh - 6vh);
  background: $bg-color;
  position: relative;
  @media (max-width: $mobile-breakpoint) {
    height: auto;
  }
  video {
    object-fit: cover;
    height: 100%;
    width: 100vw;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: radial-gradient(at center center, #05050500 0%, #050505 60%);
  }
  .desc {
    position: absolute;
    bottom: 50px;
    color: #cecece;
    text-align: center;
    font-size: 90px;
    font-style: normal;
    font-weight: 500;
    line-height: 100px; /* 104.167% */
    letter-spacing: -1.8px;
    width: 100%;
  }
}
</style>
